const ErrorPage = () => {
    return (
        <div>
            <h1>Woah</h1>
            <p>How'd you get here?</p>
        </div>
    );
};

export default ErrorPage;
